export const PRIVATE_WATER_TITLE = 'Private water';
export const PRIVATE_WATER_DESCRIPTION = 'No public access';
